import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { NitrateSensorNodeModel } from './NitrateSensorNodeModel';
import { NitrateSensorNodeWidget } from './NitrateSensorNodeWidget';

export class NitrateSensorNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.NitrateSensor);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new NitrateSensorNodeModel();
  }

  nodeUI(event) {
    return <NitrateSensorNodeWidget engine={this.engine} node={event.model} width={50} height={44} renderedOnMap />;
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
